import React from "react";
import { SiteMapContext } from "../layout";
import { Location } from "@reach/router";

export const I18WithActive = ({ id, alternateId }) => WrappedComponent => (props) => {
  return (
    <SiteMapContext.Consumer>
      {sm => {
        if (
          !sm ||
          !sm.sitemap ||
          !sm.sitemap[id] ||
          !sm.sitemap[id][sm.locale] ||
          !sm.locale
        ) {
          return <WrappedComponent {...props} />;
        }

        let mainPath = sm.sitemap[id][sm.locale].path;
        if (alternateId) {
          mainPath = mainPath + "|" + sm.sitemap[alternateId][sm.locale].path;
        }
        return (
            <Location>
              {({ location }) => {
                const r = new RegExp(mainPath, "i");
                let isActive = r.test(location.pathname);
                return <WrappedComponent className={isActive ? "active" : ""} {...props}/>;
              }}
            </Location>
        );
      }}
    </SiteMapContext.Consumer>
  );
};

export const externalHOC = ({ id, alternateId }) => WrappedComponent => {
  return props => <WrappedComponent {...props} />;
};

export const f1 = ({ id, alternateId, WrappedComponent }) => {
  return props => <WrappedComponent {...props} />;
};

export const f2 = () => {
  console.log("test")
};